import _axios from "axios";

import { Chapter } from "../interfaces/chapters.interface";

const axios = _axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_SERVER_URL,
});

export class ChapterService {
  async getChapters() {
    return axios.get("/chapters");
  }
  async updateChapter(id: string, chapter: Chapter) {
    return axios.put(`/chapters/${id}`, chapter);
  }
  async addChapter(chapter: Chapter) {
    // Remove _id when creating a new chapter
    const { _id, ...chapterWithoutId } = chapter;
    return axios.post("/chapters", chapterWithoutId);
  }
  async deleteChapter(id: string) {
    return axios.delete(`/chapters/${id}`);
  }
}
